import { cloneDeep, chunk } from 'lodash'
import { parse, stringify } from 'flatted/esm';

// That function splits payload into separate chunks, in order to send relations, repeaters, groups and the rest separetly.
// That function also filters out payload that hasn't changed.
export default function prepareSavePayload (metafieldsOriginal) {
  const metafields = parse(stringify(metafieldsOriginal)) // Do deep copy because we modify group.children
  const repeaters = []
  const relations = []
  const groups = []
  const rest = []
  const separatedGroups = []

  for (let i = 0; i < metafields.length; i++) {
    const item = metafields[i];

    if (!item.hasChanged) {
      continue
    }

    if (item.type === 'repeater') {
      repeaters.push(item)
    }

    else if (item.type === 'relation') {
      relations.push(item)
    }

    else if (item.type === 'group') {
      groups.push(
        {
          ...item,
          children: item.children.filter(item => item.hasChanged)
        })
    }

    else {
      rest.push(item)
    }
  }

  for (let i = 0; i < groups.length; i++) {
    const group = groups[i];
    const keysToSeparate = []
    for (let i = 0; i < group.children.length; i++) {
      const child = group.children[i];

      if (child.type === 'repeater' || child.type === 'relation') {
        keysToSeparate.push(child.key)
      }
    }

    if (keysToSeparate.length) {
      const newChildren = group.children.filter(item => !keysToSeparate.includes(item.key))
      const separatedChildren = group.children.filter(item => keysToSeparate.includes(item.key))

      group.children = newChildren

      for (let i = 0; i < separatedChildren.length; i++) {
        const sepChild = separatedChildren[i];

        if (sepChild.hasChanged) {
          const separatedGroup = cloneDeep(group)
          separatedGroup.children = [ sepChild ]
          separatedGroups.push(separatedGroup)
        }
      }
    }
  }
  let res = chunk(repeaters, 1).concat([ groups ], [ rest ], chunk(relations, 1))
  
  if (separatedGroups.length) {
    res = res.concat(chunk(separatedGroups, 1))
  }

  res = res.filter(item => item && item.length)

  return res
}


// WEBPACK FOOTER //
// ./src/helpers/prepare-save-payload.js